import * as yup from 'yup';

// No direct type import; we expose a Yup schema type

export const validation: yup.AnyObjectSchema = yup
  .object()
  .shape({
    // Toggle field
    useGitOps: yup.boolean().required(),

    // Helm atomic option applies to both modes
    atomic: yup.boolean().required('Please select a rollback strategy.'),

    // Manual mode fields - required when useGitOps is false
    version: yup.string().when('useGitOps', {
      is: false,
      then: (schema) =>
        schema.required('Please select a version to upgrade to.'),
      otherwise: (schema) => schema,
    }),
    repo: yup.string(),
    registryId: yup.number(),
    chart: yup.string().when('useGitOps', {
      is: false,
      then: (schema) => schema.required('Please select a chart.'),
      otherwise: (schema) => schema,
    }),
    values: yup.string(),

    // Git mode fields - required when useGitOps is true
    RepositoryURL: yup.string().when('useGitOps', {
      is: true,
      then: (schema) =>
        schema
          .required('Repository URL is required')
          .test('valid URL', 'The URL must be a valid URL', (value) => {
            if (!value) return false;
            try {
              const url = new URL(value);
              return !!url.hostname;
            } catch {
              return false;
            }
          }),
      otherwise: (schema) => schema,
    }),
    RepositoryURLValid: yup.boolean().when('useGitOps', {
      is: true,
      then: (schema) =>
        schema.test(
          'repository-valid',
          'Repository URL must be valid',
          (value) => value === true
        ),
      otherwise: (schema) => schema,
    }),
    HelmChartPath: yup.string().when('useGitOps', {
      is: true,
      then: (schema) => schema.required('Helm chart path is required'),
      otherwise: (schema) => schema,
    }),
    HelmValuesFiles: yup
      .array(yup.string().required('Path is required'))
      .default([]),
    RepositoryReferenceName: yup.string(),
    TLSSkipVerify: yup.boolean().default(false),
    RepositoryAuthentication: yup.boolean().default(false),
    RepositoryUsername: yup.string(),
    RepositoryPassword: yup.string(),
    RepositoryGitCredentialID: yup.number(),
    RepositoryAuthorizationType: yup.number(),
    NewCredentialName: yup.string(),
    SaveCredential: yup.boolean(),

    // Auto update fields (only relevant in Git mode)
    AutoUpdate: yup.object().shape({
      RepositoryAutomaticUpdates: yup.boolean().default(false),
      RepositoryMechanism: yup
        .string()
        .oneOf(['Webhook', 'Interval'])
        .default('Interval'),
      RepositoryFetchInterval: yup.string().default('5m'),
      ForcePullImage: yup.boolean().default(false),
      RepositoryAutomaticUpdatesForce: yup.boolean().default(false),
    }),
    webhookId: yup.string(),
  })
  .test(
    'either-registry-or-repo',
    'Please select a registry or repository.',
    function validateRegistryOrRepo(values) {
      // Only validate registry/repo when in manual mode
      if (values.useGitOps) {
        return true;
      }

      if (!values.registryId && !values.repo) {
        return this.createError({
          path: 'registryId',
          message: 'Please select a registry or repository.',
        });
      }
      return true;
    }
  );
